import { inject } from "vue"
import $ from "jquery"
import { useCookies } from 'vue3-cookies'

const injectionKey = Symbol("authentication")
export const useAuth = () => inject(injectionKey)

export const plugin = {
    install(app) {
        const cookies = useCookies().cookies;
        const accesses = cookies.get("accesses") ?? {};
        const auth = {
            news: {
                create: accesses.news_create ?? false,
                edit: accesses.news_edit ?? false,
                delete: accesses.news_delete ?? false,

                // levelOfAccess: levelOfAccess[accesses.news_access_level] ?? levelOfAccess.nothing,
                levelOfAccess: (Array.isArray(accesses.news_access_level) ? accesses.news_access_level : []).map(level => levelOfAccess[level] ?? levelOfAccess.nothing) ?? [],
                validation: {
                    create: validationLevel[accesses.news_validate_creation] ?? validationLevel.no_publish,
                    edit: validationLevel[accesses.news_validate_edition] ?? validationLevel.no_publish
                },
            },
            users: {
                create: accesses.users_create ?? false,
                edit: accesses.users_edit ?? false,
                delete: accesses.users_delete ?? false
            },
            pages: {
                create: accesses.pages_create ?? false,
                edit: accesses.pages_edit ?? false,
                delete: accesses.pages_delete ?? false,
                move: accesses.pages_move ?? false,
            }
        };

        // $.ajax({
        //     url: "http://localhost:8888/get-accesses",
        //     method: "GET",
        //     dataType: "json",
        //     xhrFields: {
        //         withCredentials: true,
        //     },
        //     success(data) {                
        //         const auth = {
        //             news: {
        //                 create: data.news_create,
        //                 edit: data.news_edit,
        //                 delete: data.news_delete,
        
        //                 levelOfAccess: levelOfAccess[data.news_access_level],
        //                 validation: {
        //                     create: validationLevel[data.news_validate_creation],
        //                     edit: validationLevel[data.news_validate_edition]
        //                 },
        //             },
        //             users: {
        //                 create: data.users_create,
        //                 edit: data.users_edit,
        //                 delete: data.users_delete
        //             }
        //         };
        
        //         app.provide(injectionKey, auth)
        //         app.config.globalProperties.$auth = auth
        //     }
        // })

        // const auth = {
        //     news: {
        //         create: false,
        //         edit: false,
        //         delete: false,

        //         levelOfAccess: levelOfAccess.nothing,
        //         validation: {
        //             create: validationLevel.no_publish,
        //             edit: validationLevel.no_publish
        //         },
        //     },
        //     users: {
        //         create: false,
        //         edit: false,
        //         delete: false
        //     }
        // };
        app.provide(injectionKey, auth)
        app.config.globalProperties.$auth = auth

    }
}

export const levelOfAccess = {
    public: Symbol("public"),
    ali_ibn_musa: Symbol("ali_ibn_musa"),
    karimeh: Symbol("karimeh"),
    imam_javad: Symbol("imam_javad"),
    sadr: Symbol("sadr"),
    markaz_qom: Symbol("markaz_qom"),
    markaz_tehran: Symbol("markaz_tehran"),
    women_qom: Symbol("women_qom"),
    women_tehran: Symbol("women_tehran"),
    imam_kazem: Symbol("imam_kazem"),
    imam_sadeq: Symbol("imam_sadeq"),
    edu: Symbol("edu"),
    international: Symbol("international"),
    students: Symbol("students"),
    nothing: Symbol("nothing")
}

export const validationLevel = {
    public_publish: Symbol("public_publish"),
    special_publish: Symbol("special_publish"),
    no_publish: Symbol("no_publish")
}